/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { If, Then, Else } from "react-if";
import { Link, generatePath } from "react-router-dom";
import { Text, theme } from "@nordcloud/gnui";
import { Environment } from "~/components/EstateRecordsList/types";
import { ROUTES } from "~/routing/routes";
import { isNil } from "~/tools";
import { useApplicationEnvironment } from "../hooks";

type Props = {
  environment?: Environment;
  assignments?: {
    appCount: number;
    envCount: number;
  };
};

export function ApplicationEnvironmentCell({
  assignments,
  environment,
}: Props) {
  const {
    hideAssignments,
    applicationNid,
    environmentNid,
    isData,
    hasApplications,
  } = useApplicationEnvironment({ environment, assignments });

  if (isNil(environment) && isNil(assignments)) {
    return "Unallocated";
  }

  if (isData && hideAssignments) {
    return (
      <>
        <Link
          style={{ display: "block" }}
          to={generatePath(ROUTES.applications.details, {
            application: applicationNid,
          })}
        >
          {environment?.application.name}
        </Link>
        <Link
          style={{ fontSize: theme.fontSizes.sm, display: "block" }}
          to={generatePath(ROUTES.applications.environment, {
            application: applicationNid,
            environment: environmentNid,
          })}
        >
          {environment?.name}
        </Link>
      </>
    );
  }

  if (assignments == null) {
    return null;
  }

  return (
    <If condition={hasApplications}>
      <Then>
        <Text tag="span" display="block">
          {assignments.appCount} applications
        </Text>
        <Text tag="span" size="sm" color={theme.color.text.text02}>
          {assignments.envCount} environments
        </Text>
      </Then>
      <Else>
        <Text tag="span">Unallocated</Text>
      </Else>
    </If>
  );
}
